import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo-blue.png";
import {isNil} from 'lodash';
import { connect } from "react-redux";

class ProjectFinderNavBar extends Component {
  homepageLink() {
    const pathname = window.location.pathname
    if (pathname.includes("search")) {
      return (
        <Link to="/project-finder"
          data-testid="back-to-homepage-button"
          className="ds-btn _outline _padding--small-mobileOnly _fontSize--xxsmall-mobileOnly -secondary">
          Back to homepage
        </Link>
      )
    } else {
      if (!isNil(this.props.user.id)) { return; }

      return (
        <a
          href="https://www.firstcircle.ph"
          data-testid="back-to-homepage-button"
          className="ds-btn _outline _padding--small-mobileOnly _fontSize--xxsmall-mobileOnly -secondary"
        >
          Back to homepage
        </a>
      )
    }
  }

  render() {
    return (
      <div className="project-finder-navbar">
        <div className="left">
          <img src={logo} alt="First Circle Logo.png"></img>
        </div>
        <div className="right">
          {this.homepageLink()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(ProjectFinderNavBar);



// WEBPACK FOOTER //
// ./src/features/shared/containers/ProjectFinderNavBar.js